import sdl from '@jds/react-generated-sdl/JDSInputPhoneDropdown';
import type { JDSInputPhoneDropdownProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSInputPhoneDropdownProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    open = false,
    disabled = false,
    ariaLabel = 'Select Country Code',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { open, disabled, ariaLabel, ...rest },
    'JDSInputPhoneDropdown',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputPhoneDropdown = withLogic(
  Component
) as React.FC<JDSInputPhoneDropdownProps> & { slotName?: string };

InputPhoneDropdown.displayName = 'InputPhoneDropdown';
InputPhoneDropdown.slotName = 'jds_input_phone_dropdown';

export { InputPhoneDropdown, type JDSInputPhoneDropdownProps };
